var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBookmarkActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4006_30472)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 22.5V3.83333C3 3.19167 3.252 2.64217 3.756 2.18483C4.25914 1.72828 4.86429 1.5 5.57143 1.5H18.4286C19.1357 1.5 19.7413 1.72828 20.2453 2.18483C20.7484 2.64217 21 3.19167 21 3.83333V22.5L12 19L3 22.5Z",
    fill: "#4776E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4006_30472"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBookmarkActive);
export default __webpack_public_path__ + "static/media/ic-bookmark-active.39761c35b36f3b88ffc16b631e19e4ca.svg";
export { ForwardRef as ReactComponent };